/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type AddSkillVersionRequestBody = {
  /**
   * The complete uploaded SKILL.md content. Handlers enforce a maximum size of 65,536 UTF-8 bytes.
   */
  content: string;
  /**
   * The optional source version this new version was derived from.
   */
  derivedFromVersionId?: string | undefined;
  /**
   * The version the caller believes is current. When set, the write is rejected as a conflict if the skill has moved on.
   */
  expectedLatestVersionId?: string | undefined;
  /**
   * The skill ID.
   */
  id: string;
};

/** @internal */
export type AddSkillVersionRequestBody$Outbound = {
  content: string;
  derived_from_version_id?: string | undefined;
  expected_latest_version_id?: string | undefined;
  id: string;
};

/** @internal */
export const AddSkillVersionRequestBody$outboundSchema: z.ZodMiniType<
  AddSkillVersionRequestBody$Outbound,
  AddSkillVersionRequestBody
> = z.pipe(
  z.object({
    content: z.string(),
    derivedFromVersionId: z.optional(z.string()),
    expectedLatestVersionId: z.optional(z.string()),
    id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      derivedFromVersionId: "derived_from_version_id",
      expectedLatestVersionId: "expected_latest_version_id",
    });
  }),
);

export function addSkillVersionRequestBodyToJSON(
  addSkillVersionRequestBody: AddSkillVersionRequestBody,
): string {
  return JSON.stringify(
    AddSkillVersionRequestBody$outboundSchema.parse(addSkillVersionRequestBody),
  );
}
